const theme = [
  {
    hostnames: [],
    name: "Sentinel",
    entityName: "Sentinel",
    path: "sentinel",
    dark: {
      primary: "#1169EE",
      secondary: "#1169EE",
      accent: "#8c9eff",
      success: "#4CAF50",
      info: "#5bc0de",
      warning: "#1565C0",
      error: "#FF1167",
      background: "#F2F2ED",
    },
    light: {
      primary: "#1169EE",
      secondary: "#1169EE",
      accent: "#8c9eff",
      success: "#4CAF50",
      info: "#5bc0de",
      warning: "#1565C0",
      error: "#FF1167",
      background: "#F2F2ED",
    },
    colorVariables: {
      primary: "#1169EE",
      secondary: "#1169EE",
      navigationBarBackgroundColor: "rgba(0, 0, 0, 0.02)",
      navigationBarColor: "#000000",
      background: "#F2F2ED",
    },
  },
  {
    hostnames: ["seanapps"],
    name: "Beneteau",
    entityName: "Seanapps",
    path: "seanapps",
    dark: {
      primary: "#00006e",
      secondary: "#0087ff",
      accent: "#7CB342",
      success: "#4CAF50",
      info: "#6156d8",
      warning: "#1565C0",
      error: "#FF1167",
      background: "#F2F2ED",
    },
    light: {
      primary: "#00006e",
      secondary: "#0087ff",
      accent: "#7CB342",
      success: "#4CAF50",
      info: "#6156d8",
      warning: "#1565C0",
      error: "#FF1167",
      background: "#F2F2ED",
    },
    colorVariables: {
      primary: "#00006e",
      secondary: "#0087ff",
      navigationBarBackgroundColor: "#0087ff",
      navigationBarColor: "white",
      background: "#F2F2ED",
    },
  },
];

const defaultTheme = theme.find((element) => element.name === "Sentinel");

export default {
  theme,
  defaultTheme,
};
